module.exports = __webpack_public_path__ + "img/1588389374.29421d90.jpg";